import { isYMEnabled } from './is-ym-enabled';
import { EcpLocatorEvent } from '../../models/ya-metrica-events';

export const pushEcpLocatorEvent = (event: EcpLocatorEvent, code: string): void => {
  if (isYMEnabled() && !!code && !!event) {
    window?.dataLayer?.push({
      event,
      RUSq: code,
    });
  }
};